import { render, staticRenderFns } from "./cAppLocalizationSelect.vue?vue&type=template&id=50fa29a4&"
import script from "./cAppLocalizationSelect.vue?vue&type=script&lang=js&"
export * from "./cAppLocalizationSelect.vue?vue&type=script&lang=js&"
import style0 from "./cAppLocalizationSelect.vue?vue&type=style&index=0&id=50fa29a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports